import { CustomModal } from 'components/molecules/Modal/Modal'
import { FC } from 'react'
import { TPatientStatusModalProps } from './PatientStatusModal.types'
import { FormControl } from '@mui/material'
import { usePatientStatusModalLogic } from './PatientStatusModal.logic'
import InventoryProvider from 'lib/apollo/inventory-config'
import SelectInput from 'components/SelectInput/SelectInput'
import { EPatientStatus } from 'views/RoomView/RoomView.types'

export const PatientStatusModal: FC<TPatientStatusModalProps> = (props) => {
  const logic = usePatientStatusModalLogic(props)

  return (
    <InventoryProvider>
      <CustomModal
        open
        isLoadingState={logic.isLoading}
        header={`Change Status For ${logic.patientName}`}
        primaryButtonText="SUBMIT"
        secondaryButtonAction={logic.closeModal}
        handleOnSubmit={(e) => {
          if (e) logic.handleSubmit(e)
        }}
      >
        <FormControl fullWidth sx={{ my: 2 }}>
          <SelectInput
            id="currentStatus"
            name="currentStatus"
            label="Current Status"
            variant="outlined"
            value={logic.formData.currentStatus}
            options={logic.patientStatusOptions}
            sx={{
              my: 0,
              backgroundColor: 'grayscale.lightest',
            }}
            disabled
          />
        </FormControl>

        <FormControl fullWidth sx={{ my: 2 }}>
          <SelectInput
            id="changeStatus"
            name="changeStatus"
            label="Change Status*"
            value={logic.formData.changeStatus}
            options={logic.patientStatusOptions}
            handleChangeFormData={logic.handleChangeFormData}
            variant="outlined"
            sx={{
              my: 0,
              backgroundColor: 'grayscale.lightest',
            }}
            disabled={logic.isLoading}
          />
        </FormControl>

        {logic.formData.roomNumberId && (
          <FormControl fullWidth sx={{ my: 2 }}>
            <SelectInput
              id="roomNumberId"
              name="roomNumberId"
              label="Room Number*"
              value={logic.formData.roomNumberId}
              options={logic.locationTreeOptions}
              handleChangeFormData={logic.handleChangeFormData}
              variant="outlined"
              sx={{
                my: 0,
                backgroundColor: 'grayscale.lightest',
              }}
              disabled={
                logic.isLoading ||
                logic.formData.changeStatus === EPatientStatus.CHECKED_OUT
              }
            />
          </FormControl>
        )}
      </CustomModal>
    </InventoryProvider>
  )
}
